import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted } from "vue";
  import { useAuthStore } from "./stores/auth-store";
  import { useSettingsStore } from "./stores/settings-store";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const settingsStore = useSettingsStore();

  onMounted(() => {
    settingsStore.updateBrand("Default");

    var id = window.setTimeout(function () { }, 0);

    while (id--) {
      window.clearTimeout(id);
    }
  })

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, { class: "" }))
}
}

})